import { render } from "./ChartOfAccounts.vue?vue&type=template&id=5d222f86&ts=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=ts"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__